import React from 'react';
import { bool, func } from 'prop-types';
import { translate } from 'react-i18next';
import BasicModalLayoutFooter from '../ModalLayout/BasicModalLayoutFooter';
import InformativeModalLayout from '../InformativeModalLayout';
import SomethingWentWrongSvg from '../InformativeModalLayout/SomethingWentWrongSvg';
import { Modal } from 'wix-style-react';

export class OrderPlacementErrorModal extends React.Component {
  refreshSession = () => {
    const { onRequestClose, clearCustomerSession, phoneChange, customer } = this.props;

    clearCustomerSession();
    phoneChange({ phone: customer.phone });
    onRequestClose();
  };

  render() {
    const { isOpen, onRequestClose, t } = this.props;
    const footer = (
      <BasicModalLayoutFooter
        okText={t('phoneordering_popup_error_configuration_CTA')}
        onOkClick={this.refreshSession}
        displayCancelButton={false}
      />
    );

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        dataHook="modal-order-confirmation"
        shouldCloseOnOverlayClick
      >
        <InformativeModalLayout
          shouldNOTRenderX={true}
          illustration={<SomethingWentWrongSvg />}
          title={t('phoneordering_popup_error_configuration_title')}
          content={t('phoneordering_popup_error_configuration_text')}
          footer={footer}
          onCloseClick={onRequestClose}
        />
      </Modal>
    );
  }
}

OrderPlacementErrorModal.displayName = 'OrderPlacementErrorModal';
OrderPlacementErrorModal.propTypes = {
  isOpen: bool.isRequired,
  onRequestClose: func.isRequired,
};

export default translate()(OrderPlacementErrorModal);
